/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Education_PeriodInputs */

const en_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const ar_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const bn_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`২০১৮ – ২০২৩`)
};

const de_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const es_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const fr_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const pt_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const zh_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const tr_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const ru_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

const pl_education_period = /** @type {(inputs: Education_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2018 – 2023`)
};

/**
* | output |
* | --- |
* | "2018 – 2023" |
*
* @param {Education_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const education_period = /** @type {((inputs?: Education_PeriodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Education_PeriodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_education_period(inputs)
	if (locale === "bn") return bn_education_period(inputs)
	if (locale === "de") return de_education_period(inputs)
	if (locale === "es") return es_education_period(inputs)
	if (locale === "fr") return fr_education_period(inputs)
	if (locale === "pt") return pt_education_period(inputs)
	if (locale === "zh") return zh_education_period(inputs)
	if (locale === "tr") return tr_education_period(inputs)
	if (locale === "ru") return ru_education_period(inputs)
	if (locale === "pl") return pl_education_period(inputs)
	return en_education_period(inputs)
});